import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class Notifications {
  async getNotifications(User_id, getOlderNotification) {
    return (await fetchApi.get(`/notifications?User_id=${User_id}&getOlderNotification=${getOlderNotification}`)).data;
  }

  async setSeenNotifications(User_id) {
    return (await fetchApi.patch(`/notifications/${User_id}`)).data;
  }
}
